// Dynamically load when the user scrolls to these elements.
// just add another file, then use the module to switch between them.

// Rollup will replace `__assetPath__` with the different paths
// that either contain the version number i.e. `3.0.4` OR
// the bare import specifier i.e. `@rhds/elements`.
const assetPath = '__assetPath__';
const lazyLoadJS = {
  'rh-footer': {
    script: `${ assetPath }/rh-footer/rh-footer.js`
  },
  'rh-footer-universal': {
    script: `${ assetPath }/rh-footer/rh-footer-universal.js`
  }
};

const options = {
  // Offset it slightly so the script kicks off
  // before the custom element is in view.
  rootMargin: '200px',
  threshold: 0
};
const observer = new IntersectionObserver(function (elements) {
  elements.forEach((el) => {
    if (el.isIntersecting) {
      // If the custom element is intersecting,
      // dynamically import the script.
      const selector = el.target.nodeName.toLowerCase();
      import(lazyLoadJS[selector].script);
      // Now that the script is loaded, we don't want to
      // keep observing this element, so remove it.
      observer.unobserve(el.target);
    }
  });
}, options);

Object.keys(lazyLoadJS).forEach(elName => {
  const element = document.querySelector(elName);
  if (element) {
    observer.observe(element);
  }
});
